import hero640 from "@/assets/hero-640.webp";
import hero960 from "@/assets/hero-960.webp";
import hero1350 from "@/assets/hero-1350.webp";
import logo240 from "@/assets/logo-240.webp";
import logo480 from "@/assets/logo-480.webp";

/**
 * Optimised responsive images. These are bundled by Vite with content hashed
 * file names so they can be cached immutably, and served in WebP at
 * resolutions that match real display sizes instead of the original
 * oversized JPEG/PNG uploads.
 */
export const LOGO = {
  src: logo480,
  srcSet: `${logo240} 240w, ${logo480} 480w`,
  width: 1280,
  height: 1024,
};

/**
 * The physiotherapist portrait shown in the home page hero. The original
 * artwork's phone number was removed from the banner; contact details now
 * come only from the site's own buttons and footer.
 */
export const HERO = {
  src: hero960,
  srcSet: `${hero640} 640w, ${hero960} 960w, ${hero1350} 1350w`,
  sizes: "(max-width: 768px) 100vw, 50vw",
  width: 1264,
  height: 848,
};
